import { Injectable } from '@angular/core';
import { StorageKey } from '@app/_models/enum';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class BaseService {

  secretKey = "gc@795"

  constructor() { }

  uniqueId() {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < 10) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  encrypt(plainText: any) {
    const ciphertext = CryptoJS.AES.encrypt(plainText.ToString(), this.secretKey);
    return ciphertext;
  }

  decrypt(ciphertext: any) {
    const plainText = CryptoJS.AES.decrypt(ciphertext.ToString(), this.secretKey).toString(CryptoJS.enc.Utf8);
    return plainText;
  }

  objectEncrypt(plainText: any): string {
    return CryptoJS.AES.encrypt(JSON.stringify(plainText), this.secretKey).toString();
  }

  objectDecrypt(ciphertext: any): JSON {
    if (ciphertext != null) {
      var bytes = CryptoJS.AES.decrypt(ciphertext, this.secretKey);
      try {
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      } catch {
        return undefined;
      }
    }
    return undefined;

  }

  setSessionStorage(key: string, value: any) {
    sessionStorage.setItem(key, this.objectEncrypt(value));
  }

  getSessionStorage(key: string): any {
    return this.objectDecrypt(sessionStorage.getItem(key));
  }

  encryptPass(msg) {
    // random salt for derivation
    var keySize = 256;
    var salt = CryptoJS.lib.WordArray.random(16);
    // well known algorithm to generate key
    var key = CryptoJS.PBKDF2(this.secretKey, salt, {
      keySize: keySize / 32,
      iterations: 100
    });
    // random IV
    var iv = CryptoJS.lib.WordArray.random(128 / 8);
    // specify everything explicitly
    var encrypted = CryptoJS.AES.encrypt(msg, key, {
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC
    });
    // combine everything together in base64 string
    var result = CryptoJS.enc.Base64.stringify(salt.concat(iv).concat(encrypted.ciphertext));
    return result;
  }

  storageUserSessionAction() {
    window.onstorage = event => {
        if (event.storageArea === sessionStorage) {
            if (event.key === StorageKey.Identity || event.key === null) {
              sessionStorage.clear();
                window.location.reload();
            }
        }
    };
}


}
